import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../../../constants/endpoints';

export interface ValidateAttributesRequest {
  attributeId: number,
  attributeValue: number,
  encounterId: number,
}

export interface ValidateAttributesResponse {
  message: string,
  status: string,
}

export default class ValidateAttributesService {
  public static execute({ attributeId, attributeValue, encounterId }: ValidateAttributesRequest): Promise<ValidateAttributesResponse> {
    return HttpService
      .get<ValidateAttributesResponse>(Endpoint.ADEP_VALIDATE_VITAL_SIGNS_ATTRIBUTES, { attributeId, attributeValue, encounterId })
      .then(response => {
        const responseBody = response.body as ValidateAttributesResponse;
        return responseBody
      });
  }
}